import React from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const FactoryAutomationVideoCard_1 = () => {
  return (
    <div className="card w-50 h-auto">
      <div className="card-body bg-dark text-white">
        <h5 className="card-title">SMALL INTEGRATION, HIGH IMPACT</h5>
        <p className="card-text">
          I like to use this project as an example of how as Automation Engineer
          is not alway easy to sell an idea, this project was presented several
          times to managment, same times rejected, but finally after 2 years of
          trying was approved.
        </p>

        <h6>
          Investment: <span>$45,000 USD</span>
        </h6>
        <h6>
          Time to build: <span>6 months</span>
        </h6>
        <h6>
          Savings: <span>3 re-located DL</span>
        </h6>
        <h6>
          Technology: <span>Full Automatic, 2 Stations, Neumatics, PLC Control, HMI</span>
        </h6>
      </div>
    </div>
  );
};

export default FactoryAutomationVideoCard_1;
